// extracted by mini-css-extract-plugin
export default {"container":"SessionResources_container__0NAWp"};